import { Button } from '@/components/form/baseInputs/Button';
import { UsersXIcon } from '@/components/icons/UsersXIcon';
import { FamilyTreeWarningType } from '@/types/schema';
import { pluralize } from '@/utils/formatting/strings';

import { useFamilyTreeContext } from '../contexts';

export function UnlinkedIndividualsButton() {
  const { state, dispatch } = useFamilyTreeContext();

  const numUnlinkedIndividuals =
    state.familyTreeData?.warnings.filter(
      (warning) => warning.type === FamilyTreeWarningType.UnlinkedFamilyMember
    ).length ?? 0;

  const openUnlinkedSidePanel = () => {
    dispatch({ type: 'OPEN_SIDE_PANEL', personId: '', variant: 'unlinked' });
  };

  if (numUnlinkedIndividuals === 0) return null;

  return (
    <Button
      variant="secondary"
      onClick={openUnlinkedSidePanel}
      size="sm"
      startIcon={UsersXIcon}
    >
      {`${numUnlinkedIndividuals} unlinked ${pluralize({ count: numUnlinkedIndividuals, singular: 'individual', plural: 'individuals', includeCount: false })}`}
    </Button>
  );
}
